"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Party = void 0;
const definables_1 = require("definables");
const Player_1 = require("./Player");
class Party extends definables_1.Definable {
    constructor(options) {
        super(options.id);
        this._playerIDs = [];
    }
    get playerIDs() {
        return this._playerIDs;
    }
    get players() {
        return this._playerIDs.map((playerID) => (0, definables_1.getDefinable)(Player_1.Player, playerID));
    }
    set playerIDs(players) {
        this._playerIDs = players.map((playerID) => playerID);
    }
}
exports.Party = Party;
